import { defineNuxtPlugin } from "#app";

import { JobScheduleFieldType } from "@peninsula/fieldTypes";
import calendarStore from "@peninsula/store/calendar";
import { PeninsulaCalendarViewType } from "@peninsula/viewTypes";

export default defineNuxtPlugin({
  name: "peninsula",
  dependsOn: ["database", "database-store"],
  setup(nuxtApp) {
    const context = { app: nuxtApp };
    const { $registry, $store } = nuxtApp;

    $store.registerModuleNuxtSafe(
      "page/view/peninsula_calendar",
      calendarStore,
    );
    $store.registerModuleNuxtSafe(
      "template/view/peninsula_calendar",
      calendarStore,
    );
    $registry.register("field", new JobScheduleFieldType(context));
    $registry.register("view", new PeninsulaCalendarViewType(context));
  },
});
